import React, { useState, forwardRef, useEffect } from 'react';
import { Input } from 'antd';
import classnames from 'classnames';

import { validateEmail } from 'common/helpers/validate';

export default forwardRef(function VirtualCreditCardMethod(
  { t, queryParams, setQueryParams },
  ref,
) {
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState();

  const handleValidate = value => {
    if (!value) {
      setError(true);
      setErrorMsg(t('properties.listing_management.payment_method.input_error.empty'));
      setQueryParams({
        ...queryParams,
        isValid: false,
        data: {
          email: null,
        },
      });
      return false;
    }

    if (!validateEmail(value)) {
      setError(true);
      setErrorMsg(t('properties.listing_management.payment_method.input_error.email'));
      setQueryParams({
        ...queryParams,
        isValid: false,
        data: {
          email: null,
        },
      });
      return false;
    }
    setError(false);
    setQueryParams({
      ...queryParams,
      isValid: true,
      data: {
        email: value,
      },
    });
    return true;
  };

  const handleOnChange = event => {
    const inputValue = event.target.value;
    handleValidate(inputValue);
  };

  useEffect(() => {
    ref.current = handleValidate;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <p className="method-desc" style={{ marginBottom: 8 }}>
        {t('properties.listing_management.payment_method.vcc.desc1')}
      </p>
      <p className="method-desc">{t('properties.listing_management.payment_method.vcc.desc2')}</p>
      <div className="method-input-wrapper">
        <div className="label">{t('properties.listing_management.payment_method.vcc.title')}</div>
        <div className={classnames('input-container', error && 'input-error-container')}>
          <Input
            onChange={handleOnChange}
            placeholder="Please input Email for receiving code"
            defaultValue={queryParams?.data?.email}
          />
          {error && <span className="input-error">{errorMsg}</span>}
        </div>
      </div>
    </div>
  );
});
